import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import QuickNavigation from './components/QuickNavigation';
import SocialProofSection from './components/SocialProofSection';
import BookHeroSection from "./components/BookHeroSection";
import Footer from "../../components/ui/Footer";

const HomepageLiteraryUniverseHub = () => {
  return (
    <div className="min-h-screen bg-background overflow-hidden">
      <Header />
      <main className="pt-16 lg:pt-20">
        <HeroSection />
        <BookHeroSection />

        <QuickNavigation />

        <SocialProofSection />
      </main>
      <Footer/>
    </div>
  );
};

export default HomepageLiteraryUniverseHub;